<template lang="pug">
    div
      span(v-shortkey="['-']", @shortkey="commitNone")
      .p-2
        .pt-2.relative.mx-auto.text-gray-600.w-full
          div.absolute.top-0.mt-4.pl-2
            i.fas.fa-search
          input.pl-8.border-2.border-gray-300.bg-white.h-10.px-5.pr-40.rounded-lg.text-xs.w-full(
            class="focus:outline-none", 
            type="text", 
            placeholder="Buscar",
            ref="search",
            @keyup.up.stop="highlightPrev",
            @keyup.down.stop="highlightNext",
            @keyup.enter.prevent.stop="commitSelection",
            @keydown.esc.prevent.stop="close",
            v-model="searchTerm"
          )
          div.absolute.top-0.right-0.mt-4.pr-2.cursor-pointer(@click="commitNone")
            i.fas.fa-minus-circle

      .mt-2
        transition(name="fade", mode="out-in")
          .flex.justify-center.m-4.items-center.w-full(v-if="isLoading")
            i.fas.fa-circle-notch.fa-spin.fa-2x.text-primary
          transition-group.pl-2.pr-2(name="slide-up", tag="div", v-else)
            .flex.bg-white.border.border-l-8.border-gray-200.rounded.shadow.mb-2.shadow-lg.pl-2.cursor-pointer(
              v-for="(item, index) in shadowList",
              class="hover:bg-gray-200 hover:text-primary hover:border-primary",
              @click="select(index)",
              :class="{'bg-gray-100': index === highlightedIndex, 'text-primary': index === highlightedIndex, 'border-primary': index === highlightedIndex}",
              ref="option"
              :key="index + 1"
            )
              .flex.items-center.p-2
                span.flex-1.ml-5.font-bold {{item.nombre}}
        transition(name="fade", mode="out-in")          
          div.px-3.py-2.text-purple(v-show="shadowList.length === 0 && !isLoading")
            span No hay resultados para "{{ searchTerm }}"
</template>
<script>
import { apiGet, notify } from '../util/general.js'
export default {
  name:'doctor-seleccionar',
  data () {
    return {
      lista            : [],
      highlightedIndex : 0,
      searchTerm       : '',
      isLoading        : true
    }
  },
  computed: {
    shadowList () {
      if (this.searchTerm) {
        return this.lista.filter(o =>
          o.nombre.toLowerCase().includes(this.searchTerm.toLowerCase()) || o.nombre.toLowerCase().includes(this.searchTerm.toLowerCase())
        )
      } else {
        return this.lista
      }
    }
  },
  created () {
    var vm = this
    vm.fetch()
  },
  mounted () {
    var vm = this
    vm.$refs.search.focus()
    vm.highlightedIndex = 0
  },
  methods : {
    fetch ()  {
      var vm = this
      var url = '/doctor'
      vm.isLoading = true
      var obj = {}
      apiGet(vm, url, obj, function (data)  {
        vm.lista = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    seleccionar (o) {
      var vm = this
      vm.$emit('selected', o)
    },
    highlight (index) {
      this.highlightedIndex = index
      this.$nextTick(() => {
        this.$refs.option[index].scrollIntoView({ block: 'nearest' })
      })
    },
    highlightPrev () {
      this.highlight(
        this.highlightedIndex - 1 < 0
          ? this.shadowList.length - 1
          : this.highlightedIndex - 1
      )
    },
    highlightNext () {
      this.highlight(
        this.highlightedIndex + 1 >= this.shadowList.length
          ? 0
          : this.highlightedIndex + 1
      )
    },
    close () {
      this.$emit('close')
    },
    select (index) {
      this.highlightedIndex = index
      this.commitSelection()
    },
    commitSelection () {
      this.$emit('selected', this.shadowList[this.highlightedIndex])
    },
    commitNone () {
      this.$emit('selected', {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// c_doctor_seleccionar.vue?73083990